// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gift"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 15L22 7L2 7L2 15L22 15Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22 21L22 15L2 15L2 21L22 21Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 21L2 21M22 21V7L2 7L2 21M22 21V15L2 15L2 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 4C12 5.65685 10.6569 7 9 7C7.34315 7 6 5.65685 6 4C6 2.34315 7.34315 1 9 1C10.6569 1 12 2.34315 12 4ZM12 4C12 5.65685 13.3431 7 15 7C16.6569 7 18 5.65685 18 4C18 2.34315 16.6569 1 15 1C13.3431 1 12 2.34315 12 4ZM8 11L12 7L16 11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GiftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gift',
    ref,
    icon: element,
  },
));

GiftIcon.displayName = 'GiftIcon';

export default GiftIcon;
